module.exports = __webpack_public_path__ + "img/logo7.a781cd0c.png";